export default __webpack_public_path__ + "locales/fi/ConnectDialog.json?hash=045ed4d3a0b29ed38eca26b6475b1c26";